"use client";

import {JSX} from "react";

import {telHref} from "@/shared/lib/helpers/parsers";
import {Typography} from "@/shared/ui/data-display/typography";

import "./styles/contact-info.scss";

export interface ContactInfoPhone {
    label: string;
    number: string;
}

export interface ContactInfoProps {
    title: string;
    phones: Array<ContactInfoPhone>;
    addressLines: Array<string>;
    /** When true (destinations-layout only), render phone rows from `phones`. */
    showPhones?: boolean;
    className?: string;
}

export function ContactInfo({title, phones, addressLines, showPhones = false, className = ""}: ContactInfoProps): JSX.Element {
    return (
        <div className={`contact_info_footer ${className}`}>
            <Typography as="h3" className="contact_info_footer__title">
                {title}
            </Typography>

            <div className="contact_info_footer__content">
                {showPhones &&
                    phones.map((row, index) => (
                        <div key={index} className="contact_info_footer__row">
                            <Typography as="span" color="paragraph" size={12}>
                                {row.label}
                                <a href={telHref(row.number)} className="contact_info_footer__phone">
                                    <Typography as="span" color="paragraph" weight={700} size={12}>
                                        {row.number}
                                    </Typography>
                                </a>
                            </Typography>
                        </div>
                    ))}

                {addressLines.length > 0 && (
                    <div className="contact_info_footer__address">
                        <ul>
                            {addressLines.map((line, index) => (
                                <Typography key={index} as="li" color="paragraph" size={12}>
                                    {line}
                                </Typography>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}
